import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { patientAPI } from '../services/api';

function BirthdayList() {
  const navigate = useNavigate();
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchBirthdays();
  }, []);

  const fetchBirthdays = async () => {
    try {
      setLoading(true);
      const response = await patientAPI.getTodayBirthdays();
      setPatients(response.data.data);
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch today\'s birthdays');
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (patientId) => {
    navigate(`/patient/${patientId}`);
  };

  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  return (
    <div className="card">
      <h2>🎂 Today's Birthdays</h2>
      <p style={{ color: '#666', marginBottom: '1.5rem' }}>
        List of patients celebrating their birthday today ({new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric' })}).
      </p>

      {error && <div className="error-message">❌ {error}</div>}

      {loading ? (
        <div className="loading">Loading today's birthdays...</div>
      ) : patients.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
          🎉 No birthdays today!
        </div>
      ) : (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Patient ID</th>
                <th>Name</th>
                <th>Age</th>
                <th>Gender</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {patients.map(patient => (
                <tr key={patient.id} onClick={() => handleViewDetails(patient.id)} style={{ cursor: 'pointer' }}>
                  <td><strong>{patient.patientId || '-'}</strong></td>
                  <td>{patient.firstName} {patient.lastName}</td>
                  <td>{calculateAge(patient.dateOfBirth)} years</td>
                  <td>{patient.gender}</td>
                  <td>{patient.phone}</td>
                  <td>{patient.email || '-'}</td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleViewDetails(patient.id)}
                      style={{ padding: '0.5rem 1rem', fontSize: '0.875rem' }}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ marginTop: '2rem' }}>
        <button
          className="btn btn-secondary"
          onClick={() => navigate('/patients')}
        >
          Back to Patient List
        </button>
      </div>
    </div>
  );
}

export default BirthdayList;
